import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { useTranslation } from '@eruvaka/web-pondlogs-i18n';
export const RestorePondDialog = memo((props) => {
    const { open, pond, onClose, onConfirm } = props;
    const { t } = useTranslation('ponds');
    const [isRestoring, setIsRestoring] = useState(false);
    const [error, setError] = useState(null);
    const handleClose = () => {
        setError(null);
        onClose();
    };
    const handleConfirm = async () => {
        if (!pond)
            return;
        setIsRestoring(true);
        setError(null);
        try {
            await onConfirm(pond.id);
            handleClose();
        }
        catch (err) {
            const errCode = err.errorCode ?? '';
            setError(errCode === 'FORBIDDEN' ? 'errors.permissionDenied' : 'errors.restoreFailed');
        }
        finally {
            setIsRestoring(false);
        }
    };
    return (_jsxs(Dialog, { open: open, onClose: handleClose, maxWidth: "sm", fullWidth: true, children: [_jsx(DialogTitle, { children: t('restore.title') }), _jsxs(DialogContent, { children: [_jsxs(Typography, { sx: { mb: 2 }, children: [t('restore.confirmPrefix'), ' ', _jsx(Typography, { component: "span", fontWeight: 700, children: pond?.name ?? '' }), '?'] }), _jsx(Alert, { severity: "info", sx: { mb: 2 }, children: _jsxs(Typography, { variant: "body2", children: [t('restore.infoMessagePrefix'), ' ', _jsx(Typography, { component: "span", variant: "body2", fontWeight: 700, children: t('restore.infoMessageBold') }), ' ', t('restore.infoMessageSuffix')] }) }), error && (_jsx(Alert, { severity: "error", sx: { mt: 2 }, children: t(error) }))] }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: handleClose, disabled: isRestoring, children: t('restore.cancel') }), _jsx(Button, { variant: "contained", onClick: handleConfirm, disabled: isRestoring, children: isRestoring ? t('restore.restoring') : t('restore.restorePond') })] })] }));
});
